<template>
  <v-select
    :label="title"
    :value="value"
    @input="$emit('input', $event)"
    :items="items"
    filled
    :hide-details="!isRequired"
    :rules="rules"
    clearable
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";
import helpers from "../../../helpers/helpers";

export default {
  name: "ComponentPicker",

  props: ["value", "title", "containers", "pageModel", "isRequired"],

  computed: {
    items() {
      return helpers.getComponents(this.containers);
    },
  },

  data() {
    return { rules: this.isRequired ? [ui.requiredRule] : [] };
  },
};
</script>
